import React from 'react';

import { Group, Title } from '@mantine/core';
import { DateInput } from '@mantine/dates';

interface IAthleteCreditsFilterProps {
  validityDate: Date;
  setValidityDate: (date: Date) => void;
}

const AthleteCreditsFilter = ({
  validityDate,
  setValidityDate,
}: IAthleteCreditsFilterProps): JSX.Element => {
  const handleDateChange = (date: Date): void => {
    setValidityDate(date);
  };

  return (
    <Group noWrap position='apart' p='xl' pb='xs'>
      <Title order={3} style={{ marginBottom: '0' }}>
        Credit Dispensations
      </Title>

      <DateInput value={validityDate} onChange={handleDateChange} />
    </Group>
  );
};

export default AthleteCreditsFilter;
